import {
  CHANGE_FILTER_PLACE,
  CHANGE_FILTER_SEARCH_OPTION,
  CHANGE_FILTER_STATE,
  CHANGE_SERVICE_PLACE,
  GET_ATTENDANTS,
  GET_BAR_DATA,
  GET_CALENDAR_DATA,
  GET_PIE_DATA,
  GET_PLACES,
  GET_QUEUE,
  GET_SERVICES,
  UPDATE_FILTER_SEARCH_QUERY,
  UPDATE_SELECTED_CALENDAR
} from "./types";

export const getAttendants = () => {
  return {
    type: GET_ATTENDANTS
  };
};

export const getPlaces = () => {
  return {
    type: GET_PLACES
  };
};

export const getQueue = () => {
  return {
    type: GET_QUEUE
  };
};

export const getServices = () => {
  return {
    type: GET_SERVICES
  };
};

export const getPieData = () => {
  return {
    type: GET_PIE_DATA
  };
};

export const getBarData = () => {
  return {
    type: GET_BAR_DATA
  };
};

export const getCalendarData = () => {
  return {
    type: GET_CALENDAR_DATA
  };
};

export const changeFilterSearchOption = type => {
  return {
    type: CHANGE_FILTER_SEARCH_OPTION,
    payload: type
  };
};

export const changeFilterState = type => {
  return {
    type: CHANGE_FILTER_STATE,
    payload: type
  };
};

export const changeFilterPlace = type => {
  return {
    type: CHANGE_FILTER_PLACE,
    payload: type
  };
};

export const changeFilterService = type => {
  return {
    type: CHANGE_SERVICE_PLACE,
    payload: type
  };
};

export const updateFilterSearchQuery = query => {
  return {
    type: UPDATE_FILTER_SEARCH_QUERY,
    payload: query
  };
};

export const updateSelectedCalendar = query => {
  return {
    type: UPDATE_SELECTED_CALENDAR,
    payload: query
  };
};
